<template>
  <div class="navbar">
    <div class="part-one">
      <div class="navbar-container">
        <div class="left-menu">
          <div class="user">
            <i class="el-icon-s-custom"></i>
            <span class="ml-5">{{ name }}</span>
          </div>
          <div class="oprerate ml-13">
            <el-button type="text" @click="logout">退出</el-button>
            <el-button type="text" class="ml-13" @click="updatePassword">修改密码</el-button>
          </div>
        </div>
        <div class="right-menu oprerate">
          <el-button type="text" @click="linkJump('home')">找钢网首页</el-button>
          <shop-share class="ml-42" v-if="$store.state.shop.info.id"></shop-share>
          <el-button type="text" class="ml-42" @click="linkJump('buyer')">买家中心</el-button>
          <el-button type="text" class="ml-42" @click="linkJump('seller')">胖猫掌柜</el-button>
        </div>
      </div>
    </div>
    <div class="part-two">
      <div class="navbar-container">
        <div class="platform-logo left-menu">
          <img src="@/assets/logo.png" />
          <span class="name">
            商家后台
          </span>
        </div>
        <div class="right-menu">
          <div class="shop-time-detail" v-if="$store.state.shop.info.id">
            <div>
              <span v-if="$store.state.shop.isOpen">营业中</span>
              <span class="c-f-o" v-if="!$store.state.shop.isOpen">已关店</span>
            </div>
            <div
              class="switch ml-13 cursor"
              @click="settingShopIsOpen"
              :class="{
                'switch-open': $store.state.shop.isOpen,
                'switch-close': !$store.state.shop.isOpen,
                'switch-disabled': !$store.state.shop.todayIsOpen || $store.state.shop.isTimeOut
              }"
            ></div>
            <div class="ml-13" v-if="$store.state.shop.autoOpen">
              <div v-if="$store.state.shop.isOpen">
                <time>{{ $store.state.shop.todayTime }}</time>
              </div>
              <div v-if="!$store.state.shop.isOpen">
                <time class="c-f-o" v-if="$store.state.shop.todayIsOpen">{{
                  $store.state.shop.todayTime
                }}</time>
                <span class="c-f-o" v-if="!$store.state.shop.todayIsOpen">今日休息</span>
              </div>
            </div>
            <div class="ml-13" v-if="!$store.state.shop.autoOpen">
              <div v-if="$store.state.shop.isOpen">
                <span v-if="!$store.state.shop.autoOpen">今日营业至 </span>
                <time v-if="!$store.state.shop.autoOpen">{{
                  $store.state.shop.todayTime.split('-')[1]
                }}</time>
              </div>
              <div v-if="!$store.state.shop.isOpen">
                <span class="c-f-o">今日营业至 </span>
                <time class="c-f-o">{{ $store.state.shop.todayTime.split('-')[1] }}</time>
              </div>
            </div>
          </div>
          <el-dropdown
            v-if="currentShop"
            class="avatar-container right-menu-item hover-effect ml-30"
            trigger="click"
          >
            <div class="c-f shop-current p-l15 p-r15">
              <img
                v-if="currentShop.logo"
                class="shop-current-logo"
                :src="currentShop.logo | fileUrlAdapter"
              />
              <span class="line-1 mw-350 m-l12 shop-current-name">{{
                currentShop.shopName || currentShop.orgName
              }}</span>
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu :offset="-10" slot="dropdown" class="project-dropdown">
              <el-dropdown-item
                v-for="(item, index) in shopInfoList"
                :key="index"
                @click.native="switchShop(item.orgId, item.id)"
              >
                <div class="shop-menu-item clearfix">
                  <img v-if="item.logo" class="logo" :src="item.logo | fileUrlAdapter" />
                  <div class="shop-info">
                    <template v-if="item.shopName">
                      <div class="shop-name c-3 f-14">{{ item.shopName }}</div>
                      <div class="org-name c-9 f-12">{{ item.orgName }}</div>
                    </template>
                    <span v-else class="c-3 f-14">{{ item.orgName }}</span>
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="ml-30">
            <el-button
              id="mask-setting"
              class="c-f"
              type="text"
              @click="$router.push('/shop/info?type=edit')"
              icon="el-icon-s-tools"
              >设置</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="isShowDidlog" title="修改密码" center>
      <el-form :model="pwdData" ref="udpatePwd" :rules="rules">
        <el-form-item label="旧密码" prop="oldPass" label-width="120px">
          <el-input
            type="text"
            v-model="pwdData.oldPass"
            autocomplete="off"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPass" label-width="120px">
          <el-input
            type="password"
            v-model="pwdData.newPass"
            auto-complete="new-password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认新密码" prop="password_confirmation" label-width="120px">
          <el-input
            type="password"
            v-model="pwdData.password_confirmation"
            auto-complete="off"
            :maxlength="20"
            placeholder="请确认新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowDidlog = false">取 消</el-button>
        <el-button type="danger" @click="confrimDialog">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sha1 from 'js-sha1'
import { HOME_ROOT, ZM_ROOT, V2_ROOT, BUYER, SELLER } from '@/common/constants/'
import { getWebToken, getUserId } from '@/common/utils/common'
import shopShare from './shopShare'

export default {
  computed: {
    ...mapGetters([
      'sidebar',
      'userCurrentOrg',
      'userOrgList',
      'name',
      'currentShop',
      'shopInfoList'
    ])
  },
  components: {
    shopShare
  },

  data() {
    let validPassword = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.pwdData.password_confirmation !== '') {
          this.$refs.udpatePwd.validateField('password_confirmation')
        }
        callback()
      }
    }
    let validRepPassword = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.pwdData.newPass) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      isShowDidlog: false,
      pwdData: {
        oldPass: '',
        newPass: '',
        password_confirmation: ''
      },
      rules: {
        oldPass: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        newPass: [
          { validator: validPassword, trigger: 'blur' },
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, max: 18, message: '长度必须在 8 到 18 个字符', trigger: 'blur' },
          {
            pattern: /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)/,
            message: '新密码必须包含字母数字或符号至少2种'
          }
        ],
        password_confirmation: [
          { validator: validRepPassword, trigger: 'blur' },
          { required: true, message: '请确认密码', trigger: 'blur' }
        ]
      },
      unReadCount: 0,
      V2_ROOT
    }
  },
  mounted() {
    this.getShopInfo()
  },
  methods: {
    updatePassword() {
      this.isShowDidlog = true
      this.$refs && this.$refs.udpatePwd && this.$refs.udpatePwd.resetFields()
    },
    /** 获取店铺信息 */
    async getShopInfo() {
      try {
        const result = await this.$post('shop.adminGetCurrentShop')
        if (result.success) {
          let data = result.data[0] || {}
          this.$store.dispatch('setShopInfo', JSON.parse(JSON.stringify(data)))
        } else {
          this.$message.error('获取店铺信息失败')
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 链接跳转 */
    linkJump(type) {
      if (type === 'home') {
        window.open(`${HOME_ROOT}`)
      }
      if (type === 'shop') {
        window.open(`${ZM_ROOT}/shop/${this.$store.state.shop.info.id}`)
      }
      if (type === 'buyer') {
        window.open(`${ZM_ROOT}/buyer/order`)
      }
      if (type === 'seller') {
        window.open(`${SELLER}`)
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    // 推 出
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$store.dispatch('tagsView/delAllViews')
      window.IM && window.IM.destroy()
    },
    async userChangeOrg(orgId) {
      if (orgId !== this.userCurrentOrg.id) {
        try {
          const result = await this.$store.dispatch('user/userChangeOrg', orgId)
          if (result.value) {
            this.$store.dispatch('permission/clearRoutes')
            this.$store.commit('user/SET_ROLES', [])
            this.$store.dispatch('tagsView/delAllViews')
            this.getShopInfo()
            // this.$router.push('/')
            location.replace('/')
          } else {
            this.$message.error('切换机构失败')
          }
        } catch (err) {
          console.log(err)
          this.$message.error('切换机构失败')
        }
      }
    },
    switchShop(orgId, shopId) {
      if (orgId === this.currentShop.orgId && shopId === this.currentShop.id) {
        return
      }
      this.$store
        .dispatch('user/changeUserShop', { orgId, shopId })
        .then(() => {
          this.$message.error('店铺切换成功')
          this.$store.dispatch('permission/clearRoutes')
          this.$store.commit('user/SET_ROLES', [])
          this.$store.dispatch('tagsView/delAllViews')
          this.getShopInfo()
          location.replace('/')
        })
        .catch(() => {
          this.$message.error('店铺切换失败')
        })
    },
    confrimDialog() {
      this.$refs.udpatePwd.validate(async valid => {
        if (!valid) {
          return false
        }
        let params = Object.assign({}, this.pwdData)
        params.oldPass = sha1(params.oldPass)
        params.newPass = sha1(params.newPass)
        delete params.password_confirmation
        try {
          const result = await this.$post('user.changePassword', params)
          console.log(result.success)
          if (result.success) {
            if (result.data[0] && result.data[0].value) {
              this.$message.success('密码修改成功')
              this.logout()
            } else {
              this.$message.error('修改密码失败')
            }
          }
        } catch (err) {
          console.log(err)
        }
      })
    },
    /** 设置店铺开启状态 */
    async settingShopIsOpen() {
      if (
        (this.$store.state.shop.todayIsOpen || !this.$store.state.shop.autoOpen) &&
        !this.$store.state.shop.isTimeOut
      ) {
        try {
          const result = await this.$post('shop.adminSetOpeningHours', {
            isOpen: !this.$store.state.shop.isOpen
          })
          if (result.success) {
            if (result.data[0].value) {
              this.$store.dispatch('setShopIsOpen', !this.$store.state.shop.isOpen)
            } else {
              this.$message.error('设置失败')
            }
          }
        } catch (err) {
          console.log(err)
        }
      } else {
        this.$message.warning('现在是非营业时间，请前往 “设置”手动开启营业')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 90px;
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  font-size: 14px;
  outline: none;

  .part-one {
    padding: 0 20px;
    height: 30px;
    background-color: #333;
    color: #999;
    font-size: 12px;

    .oprerate button {
      color: #999;
      font-size: 12px;
    }
  }
  .part-two {
    padding: 0 20px;
    height: 60px;
    background: linear-gradient(61deg, rgba(240, 36, 46, 1) 0%, rgba(208, 17, 26, 1) 100%);
  }

  .navbar-container {
    max-width: $maxWidth;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .line-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  .mw-350 {
    max-width: 350px;
  }
  .mw-100 {
    max-width: 100px;
  }

  .left-menu {
    flex: 1;
    text-align: left;
    display: flex;
    align-items: center;
    height: 100%;
  }
  .right-menu {
    flex: 1;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
  }
  .news {
    cursor: pointer;
  }
  .ml-5 {
    margin-left: 5px;
  }
  .ml-13 {
    margin-left: 13px;
  }
  .ml-30 {
    margin-left: 30px;
  }
  .ml-42 {
    margin-left: 42px;
  }

  .platform-logo {
    img {
      width: 140px;
      height: 30px;
    }
    .name {
      font-size: 27px;
      color: #fff;
      width: 150px;
      margin-left: 20px;
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      display: inline-block;
      text-align: center;
    }
  }

  .c-f {
    color: #fff;
    font-size: 13px;
  }
  .c-f-o {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
  }
  .shop-setting {
    height: 22px;
    line-height: 22px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    padding: 0 10px;
    width: 180px;
    text-align: right;
  }
}
.shop-time-detail {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  background: rgba(255, 255, 255, 0.04);
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 4px 10px;
  white-space: nowrap;
  .c-f-o {
    color: rgba(254, 108, 114, 1);
    font-size: 12px;
  }
  .switch {
    width: 28px;
    height: 12px;
    border-radius: 6px;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: -2px;
      width: 16px;
      height: 16px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      transition: all 0.5s;
    }
  }
  .switch-open {
    background: rgba(145, 206, 83, 1);
    &:after {
      left: 12px;
    }
  }
  .switch-close {
    background: rgba(255, 109, 115, 1);
    &:after {
      left: 0;
    }
  }
  .switch-disabled {
    background: rgba(255, 109, 115, 0.4);
    &:after {
      left: 0;
      background: rgba(255, 255, 255, 0.4);
      box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.1);
    }
  }
}
.mb-10 {
  margin-bottom: 10px;
}

.shop-current {
  .shop-current-logo {
    width: 26px;
    height: 26px;
    vertical-align: middle;
  }
  .shop-current-name {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }
}

.shop-menu-item {
  height: 64px;
  .logo {
    float: left;
    width: 30px;
    height: 30px;
    margin: 17px 12px 0 0;
  }
  .shop-info {
    float: left;
    height: 64px;
    padding-top: 14px;
    .shop-name {
      line-height: 14px;
    }
    .org-name {
      line-height: 12px;
      margin-top: 10px;
    }
  }
}
</style>
<style lang="scss">
.project-dropdown[x-placement^='bottom'] {
  max-height: 292px;
  overflow-y: scroll;
  padding: 0;
  border-radius: 0;
  li {
    padding: 0 16px;
    &:hover {
      background: #f8f8f8;
    }
  }
}
</style>
